// ─────────────────────────────────────────────────────────────
// src/pages/TaxCalculator/components/ModeSelector.jsx
// Renders the Individual / Bulk mode toggle cards.
// Pure UI – receives everything via props.
// ─────────────────────────────────────────────────────────────

import React from "react";
import { User, Users } from "lucide-react";

const ModeSelector = ({ processingMode, onSelectMode, styles, t }) => (
  <div style={styles.modeSwitch}>
    <div
      style={styles.modeSwitchButton(processingMode === "individual")}
      onClick={() => onSelectMode("individual")}
    >
      <div style={styles.modeSwitchTitle}>
        <User size={24} />
        {t.individualCalculator}
      </div>
      <div style={styles.modeSwitchDesc}>{t.individualDesc}</div>
    </div>

    <div
      style={styles.modeSwitchButton(processingMode === "bulk")}
      onClick={() => onSelectMode("bulk")}
    >
      <div style={styles.modeSwitchTitle}>
        <Users size={24} />
        {t.bulkExcelProcessor}
      </div>
      <div style={styles.modeSwitchDesc}>{t.bulkDesc}</div>
    </div>
  </div>
);

export default ModeSelector;